export const deliveryKey = (vrid: number, dlid: number): string =>
  `del-${vrid}-${dlid}`;

export const keyFromText = (source: string, prefix = ''): string => {
  const stripPunctuationsAndSpaces = /[.,/#!$%^&*;:{}=\-_`~()]/g;
  const key = source.replace(stripPunctuationsAndSpaces, '').substring(0, 7);
  const keyPrefix = prefix ? `${prefix}-` : '';

  return `${keyPrefix}${key}`;
};
